<div class="l_flex l_flex-column l_flex-center-children center-text">
  <div class="guts-p-t-5 guts-p-b-2">
    <img
      [alt]="i18n.Core_Empty_Image_Alt"
      [src]="emptyImageUrl | blobifyUrl: true"
      width="360px"
      height="275px"
      class="guts-p-b-2"
    />
    <div>
      <span class="par font-semibold">{{
        i18n.UserSettingsSvc_SettingsNotPublic
      }}</span>
    </div>
    <div>
      <span class="par--small par--light_a">{{
        i18n.UserSettingsSvc_TryLoggingIn
      }}</span>
    </div>
  </div>
</div>

<dgx-footer-glasses></dgx-footer-glasses>
